"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { CircleAlert as AlertCircle, FileText } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Privacy() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.08,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 16
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <section id="privacy-policy" data-nav="light" className="bg-background text-foreground py-14 md:py-20 lg:py-24 border-b border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-(--breakpoint-xl)">
        <motion.div className="max-w-3xl mx-auto" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: "-40px"
      }} variants={containerVariants}>
          {/* Draft Alert Status Pill */}
          <motion.div variants={itemVariants} className="mb-6 flex justify-start">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-lg bg-accent text-accent-foreground border border-border text-xs sm:text-sm font-semibold tracking-wide max-w-full whitespace-normal">
              <AlertCircle className="w-4 h-4 shrink-0 text-accent-foreground" />
              <span>DRAFT DOCUMENT — PENDING FINAL CLIENT REVIEW</span>
            </div>
          </motion.div>

          {/* Header Title Block */}
          <motion.div variants={itemVariants} className="space-y-4 mb-8 pb-6 border-b border-border">
            <div className="flex items-center gap-2 text-xs uppercase tracking-wider font-bold text-muted-foreground">
              <FileText className="w-4 h-4 text-primary" />
              <span>Fridge Fleet LLC Legal Documentation</span>
            </div>
            
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-foreground font-default">
              Privacy Policy
            </h1>
          </motion.div>

          {/* Placeholder Notice */}
          <motion.div variants={itemVariants} className="space-y-6">
            <p className="text-base sm:text-lg text-foreground leading-relaxed">
              This page is pending owner and legal review. Final privacy disclosures will be added before launch.
            </p>
          </motion.div>

          {/* Assistance & Quote Box */}
          <motion.div variants={itemVariants} className="mt-12 p-6 sm:p-8 rounded-lg bg-muted border border-border text-foreground flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div className="space-y-1">
              <h2 className="text-lg font-bold text-foreground">Have questions regarding trailer rentals?</h2>
              <p className="text-sm text-muted-foreground">
                Speak directly with dispatch or submit your project details for scheduling.
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-3 w-full sm:w-auto">
              <Button asChild size="default" className="w-full sm:w-auto font-semibold">
                <Link to="/ContactRequestAQuotePage">
                  Request a Quote
                </Link>
              </Button>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}